export default function getPageLink(page) {
  return `/pages/${page.name}`;
}
